
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import CustomSelect from 'Components/Select';

//Notification
import { NotificationManager } from "Components/Notifications";

//Styles
import './moveToAnotherAccount.scss';

//Actions
import {
    moveToAnotherAccountGetKeyFobRequest,
    moveToAnotherAccountSetDevice,
    moveToAnotherAccountRequest,
    clearRedux,
} from 'Redux/actions';

import { getAccounts } from './redux/saga'

const moveToAnotherAccount = (props) => {
    const formRef = useRef(null);
    const formTwoRef = useRef(null);
    const { messages } = useIntl();
    const { tableRef, single, getDevice, account } = props;
    const dispatch = useDispatch();

    //Redux States
    const { keyFob, loading, openModal, result, selectedKeyFobs } = useSelector(state => state.moveToAnotherAccountRedux)

    //Local States
    const [keyfobs, setKeyFobs] = useState([]);
    const [accountTo, setAccountTo] = useState(null);
    const [serial, setSerial] = useState("");


    const searchKeyFob = () => {
        let keyFobSearchCriteriaArr = serial.split(/[\s,;\t\n]+/);
        if (keyFobSearchCriteriaArr.length > 1) {
            let criterias = [];

            keyFobSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();

                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');

                if (keyfobs && keyfobs.length) {
                    for (let index in keyfobs) {
                        let keyfob = keyfobs[index];

                        if (keyfob.hex != escCriteria) {
                            criterias.push(escCriteria?.trim());
                        }
                    }
                } else {
                    criterias.push(escCriteria?.trim());
                }
            });

            if (criterias.length) {
                dispatch(moveToAnotherAccountGetKeyFobRequest(criterias));
            }

        } else {

            let isValid = true;
            for (let index in keyfobs) {
                let keyfob = keyfobs[index];
                if (keyfob.hex.toString() === serial?.trim()) {
                    isValid = false;
                    break;
                }
            }

            if (isValid) {
                dispatch(moveToAnotherAccountGetKeyFobRequest(serial?.trim()));
            } else {
                NotificationManager.warning(
                    messages['move_to_another_account_device_is_already_added'],
                    messages['move_to_another_account_title'],
                    3000
                );
            }
        }
    }

    const closeModal = () => {
        setSerial("");
        setAccountTo(null);
        setKeyFobs([]);
        dispatch(clearRedux("MOVE_TO_ANOTHER_ACCOUNT"));
    }

    const applyChanges = () => {
        let deviceValidation = keyfobs.some((item) => item.status === 1)
        if (deviceValidation && accountTo?.status !== 1) {
            NotificationManager.error(
                messages['move_to_another_account_restriction_to_move'],
                messages['move_to_another_account_title'],
                3000
            );
            return
        }
        let keyFobIds = keyfobs.map((item) => (item?.hex))
        let payload = {
            newAccountId: accountTo?.id,
            keyFobIds
        }
        dispatch(moveToAnotherAccountRequest(payload))
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }


    useEffect(() => {

        if (keyFob) {
            dispatch(clearRedux("MOVE_TO_ANOTHER_ACCOUNT", { keyFob: null }));
            if (!keyFob?.total) {
                NotificationManager.warning(
                    messages['move_to_another_account_device_has_not_been_found'],
                    messages['move_to_another_account_title'],
                    3000
                );
            } else {
                let items = keyFob.items;
                if (items?.length > 0) {
                    setSerial("");
                    let newItems = [...keyfobs, ...items]
                    dispatch(moveToAnotherAccountSetDevice(newItems))
                    setKeyFobs([...newItems]);
                }
            }

        }
        if (result?.updateMoveAccount) {
            NotificationManager.success(
                single ? messages['move_to_another_account_single_success_message'] : messages['move_to_another_account_multiple_success_message'],
                messages['move_to_another_account_title'],
                3000
            );
            closeModal();
            getDevice && getDevice();
            tableRef && tableRef?.current?.getData();
        } else if (result && !result?.updateMoveAccount) {
            NotificationManager.error(
                messages['move_to_another_account_error_message'],
                messages['move_to_another_account_title'],
                3000
            );
            dispatch(clearRedux("MOVE_TO_ANOTHER_ACCOUNT", { result: null }))
        }
        if (selectedKeyFobs && selectedKeyFobs.length > 0) {
            setKeyFobs([...selectedKeyFobs]);
            dispatch(clearRedux("MOVE_TO_ANOTHER_ACCOUNT", { selectedKeyFobs: [] }))
        }
    }, [keyFob, result, selectedKeyFobs])

    return (
        <Modal
            open={openModal}
            title={messages['move_to_another_account_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                {
                    <div style={{ padding: '0 10px', height: "75vh" }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={12}>
                                <CustomSelect
                                    async
                                    value={accountTo}
                                    onChange={(newaccount) => setAccountTo(newaccount)}
                                    label={messages['move_to_another_account_account_to']}
                                    loadOptions={getAccountsForSelect}
                                    required
                                    getOptionLabel={e => e.name}
                                    getOptionValue={e => e.id}
                                    className="account-select-move-to-other-account"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ display: "flex", width: "100%" }}>
                                    <div style={{ marginTop: 26, width: "80%" }}>
                                        <Form
                                            ref={formRef}
                                            onValidSubmit={() => searchKeyFob()}
                                        >
                                            <Input
                                                label={messages['move_to_another_account_input']}
                                                placeholder={messages['move_to_another_account_input']}
                                                value={serial}
                                                required
                                                requiredMessage={messages['required_field']}
                                                onChange={(value) => setSerial(value)}
                                            />
                                        </Form>
                                    </div>
                                    <div style={{ marginTop: 52, marginLeft: 10, width: "20%" }}>
                                        <Button
                                            className="btn-dark-blue"
                                            onClick={() => formRef?.current?.submit()}
                                        >
                                            {messages['common_add']}
                                        </Button>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        {
                            keyfobs?.length > 0 &&
                            <Grid item xs={12} style={{ marginTop: 26 }}>
                                <label style={{ fontWeight: 700 }}>{messages['move_to_another_account_keyfobs']}</label>
                            </Grid>
                        }
                        {keyfobs.length > 0 ? keyfobs.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = keyfobs;
                                        let selected = currentDevices.findIndex((keyfob) => keyfob.id === item.id);
                                        if (selected > -1) currentDevices.splice(selected, 1);
                                        dispatch(moveToAnotherAccountSetDevice(currentDevices));
                                    }}
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['move_to_another_account_identifier']}</label><span>{item.hex}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['move_to_another_account_account']}</label><span>{item?.company?.name}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['move_to_another_account_model']}</label><span>{item?.keyFobModel?.name}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_keyfobs_added']}</span></div>}
                    </div>
                }

            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        if (!accountTo) {
                            NotificationManager.warning(
                                messages['move_to_another_account_select_to_account'],
                                messages['move_to_another_account_title'],
                                3000
                            );

                        } else if (keyfobs.length === 0) {
                            NotificationManager.warning(
                                messages['move_to_another_account_no_devices_added'],
                                messages['move_to_another_account_title'],
                                3000
                            );
                        } else {
                            //account from selected and keyfobs added 
                            applyChanges();
                        }
                    }}
                >
                    {messages['move_to_another_account_change']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default moveToAnotherAccount;